<div class="popup" tabindex="-1" role="dialog" [ngClass]="isOpen ? 'open' : ''">
  <a (click)="close()"></a>

  <div class="popup-content" style="min-width: 320px">
    <h5 class="d-flex align-items-center">
      {{ transaction?.chargingStationName }} {{ getChargingPointPosition(transaction) }}

      <button type="button" class="btn-close" style="margin-left: auto" aria-label="Close" (click)="close()"></button>
    </h5>

    <h4 class="mt-4 mb-4 text-center">
      <span class="d-none">{{transaction?.id}}</span>
      <ng-container *ngIf="transaction?.isFreeCharge">
        <span i18n="@@FreeCharge">Kostenloser Ladevorgang</span>
      </ng-container>

      <ng-container *ngIf="transaction?.paymentIntentId != null">
        Gast über QR-Code-Laden
      </ng-container>

      <ng-container *ngIf="transaction?.sessionId != null">
        Gast über eRoaming
      </ng-container>

      <ng-container *ngIf="transaction?.hecId != null">
        Gast über Terminal
      </ng-container>

      <ng-container *ngIf="transaction?.userFirstName != null">
        {{ transaction?.userFirstName }} {{ transaction?.userLastName}}
      </ng-container>
    </h4>

    <h4 class="fw-bold text-center">
      <!-- kWh with one decimal digit, shows em dash '—' if n/a -->
      <span
        *ngIf="transaction?.meterAmount != null && transaction?.meterAmount != 0; then meterAmountBlock; else noMeterAmountBlock">
      </span>
    </h4>
    <ng-template #meterAmountBlock>
      {{transaction?.meterAmount | kwh:1}}&nbsp;kWh
    </ng-template>
    <ng-template #noMeterAmountBlock>
      &mdash;&nbsp;kWh
    </ng-template>

    <div style="display: flex; gap: .25rem; justify-content: center;" class="mb-4">
      <transaction-status-badge [status]="transaction?.status">
      </transaction-status-badge>

      <charging-power-profile-badge *ngIf="transaction?.chargingPowerProfile" style="position: relative;"
        [profile]="transaction?.chargingPowerProfile" [isCaptioned]="transaction?.status.id == 3">
      </charging-power-profile-badge>

      <span class="badge" style="background: transparent;" *ngIf="transaction?.currentPower"
        [ngClass]="['profile-' + transaction?.chargingPowerProfile?.key, 'colored']">
        <span>{{ transaction.currentPower | kwh }}&nbsp;kW</span>
        <!--TODO We should not be using the kWh pipe to display kW, but it is just dividing by 1000...-->
      </span>
    </div>

    <p class="text-muted" style="display: flex; flex-direction: column;">
      <small *ngIf="transaction?.rfidCardIdTag" i18n="@@TransactionDetailsRfid">
        Autorisierung mit RFID-Tag <strong>{{ transaction?.rfidCardIdTag }}</strong>
      </small>

      <small *ngIf="transaction?.startTimestamp" i18n="@@TransactionDetailsStart">
        Start am <strong>{{ transaction?.startTimestamp | dateDE }}</strong>
      </small>

      <small *ngIf="transaction?.duration" i18n="@@TransactionDetailsDuration">
        Läuft seit <strong>{{ transaction?.duration }}</strong>
      </small>

      <small *ngIf="transaction?.chargeDiameter" i18n="@@TransactionDetailsDiameter">
        Ladeleistung bei durchschnittlich {{ transaction?.chargeDiameter }} kW
      </small>
    </p>

    <div class="d-flex justify-content-center gap-1">
      <button type="button" class="btn btn-default btn-stop" (click)="openRemoteStopDialog(transaction)"
        i18n="@@remoteStopBtnText" ngbTooltip="Ladevorgang stoppen" i18n-ngbTooltip="@@StopTransaction">
        <app-svg source="icons/feather/stop-circle" height="18"></app-svg>
        &nbsp;Stoppen
      </button>
      <button type="button" class="btn btn-default" i18n="@@TransactionDetailsBtnText"
        ngbTooltip="Details zum Ladevorgang anzeigen" i18n-ngbTooltip="@@ShowTransactionDetails"
        [routerLink]="['/customers', this.customerId, 'dashboard', 'transactions', transaction?.id]"
        *ngIf="this.isOperator">
        <app-svg source="icons/feather/activity" height="18"></app-svg>
      </button>
      <button type="button" class="btn btn-default" i18n="@@TransactionDetailsBtnText"
        ngbTooltip="Details zum Ladevorgang anzeigen" i18n-ngbTooltip="@@ShowTransactionDetails"
        [routerLink]="'./transactions/'+ transaction?.id" *ngIf="this.isUser">
        <app-svg source="icons/feather/activity" height="18"></app-svg>
      </button>
      <button type="button" class="btn btn-default" i18n="@@TransactionDetailsBtnText"
        ngbTooltip="Details zum Ladevorgang anzeigen" i18n-ngbTooltip="@@ShowTransactionDetails"
        [routerLink]="'/evaluation/transactions/'+ transaction?.id" *ngIf="this.isCustomer">
        <app-svg source="icons/feather/activity" height="18"></app-svg>
      </button>

      <button type="button" class="btn btn-default" ngbTooltip="Support und Feedback absenden"
        i18n-ngbTooltip="@@SendSupportAndFeedback" (click)="openSupportPopup()">
        <app-svg source="icons/feather/support" height="18"></app-svg>
      </button>
    </div>
  </div>
</div>

<request-support-popup [transaction]="transaction" [isOpen]="isRequestingSupport" (isClosing)="closeSupportPopup()">
</request-support-popup>